import * as actionTypes from './actionTypes';

const initialState = {
  activeMailingListId: null,
  ids: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.SET_ACTIVE_MAILING_LIST_ID:
      return {
        ...state,
        activeMailingListId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.mailingList.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.id),
        activeMailingListId: action.id === state.activeMailingListId
          ? null
          : state.activeMailingListId,
      };
    default:
      return state;
  }
};
